<template>
  <v-icon icon="home" class="text-primary fa-2x" />
</template>
<script>
export default {}
</script>
